var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import ChemoProtocolCardAPI from './chemotherapy-protocol-card-api';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import React, { Component } from 'react';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { Avatar, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import './chemotherapy-protocol-card.css';
let ChemoProtocolCard = class ChemoProtocolCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { cycle, dateExpected, dateReal, day, nmProtocol, nrPrescription, nrSequence, onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        cycle,
                        dateExpected,
                        dateReal,
                        day,
                        nmProtocol,
                        nrPrescription,
                        nrSequence,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderIndicatorColorStatus() {
        return React.createElement("div", { className: 'c-clinical-notes-card__indicator-color-green' });
    }
    renderIndicator() {
        return (React.createElement("div", { className: 'c-clinical-notes-card__indicator' }, this.renderIndicatorColorStatus()));
    }
    extractNumbersFromString(inputString) {
        const numbers = inputString.match(/\d+/g);
        return numbers ? numbers.join('') : '';
    }
    renderField() {
        const { dateExpected, dateReal, nmProtocol, cycle, day } = this.props;
        let line1 = '';
        let line2 = '';
        const data = dateReal || dateExpected;
        if (nmProtocol) {
            const [l1, l2] = nmProtocol.split('/');
            line1 = l1.trim();
            line2 = l2.trim();
        }
        let dayN = '';
        if (day) {
            dayN = this.extractNumbersFromString(day);
        }
        const labelCycle = MessageService.translate('text.cycle');
        const labelDay = MessageService.translate('text.day');
        return (React.createElement("div", { className: 'c-chemotherapy-protocol-card__avatar' },
            React.createElement("div", { className: 'c-chemotherapy-protocol-card__image' },
                React.createElement(Avatar, null)),
            React.createElement("div", { className: 'c-chemotherapy-protocol-card__wrapper-left' },
                React.createElement("h5", { className: 'c-chemotherapy-protocol-card-first-line' }, line1),
                React.createElement("h5", null, line2)),
            React.createElement("div", { className: 'c-chemotherapy-protocol-card__wrapper-right' },
                React.createElement("h5", null, new Date(data).toLocaleString()),
                React.createElement("span", null, labelCycle + ' ' + cycle + ' - ' + labelDay + ' ' + dayN))));
    }
    render() {
        const { cycle, nmProtocol } = this.props;
        return (React.createElement(Card, { className: 'c-chemotherapy-protocol-card', onClick: () => this.onClick(), selectionType: SelectionType.SINGLE, uuid: generateUUID(), key: `${cycle} + ${nmProtocol}`, width: 12 },
            this.renderIndicator(),
            React.createElement("div", { className: 'c-chemotherapy-protocol-card__wrapper' }, this.renderField())));
    }
};
ChemoProtocolCard = __decorate([
    AwesomeComponent({ api: ChemoProtocolCardAPI, type: ComponentType.DATA_DISPLAY })
], ChemoProtocolCard);
export default ChemoProtocolCard;
//# sourceMappingURL=chemotherapy-protocol-card.js.map